import { jsx as o } from "react/jsx-runtime";
import { useMergeRefs as f, useTransitionStyles as g, FloatingPortal as c } from "@floating-ui/react";
import { forwardRef as d } from "react";
import { useTooltipContext as j } from "../hooks/useTooltipContext.js";
import { tv as u } from "../../tailwind-variants.config.js";
const x = u({
  base: "jm-bg-white jm-rounded-lg jm-shadow-[0px_0px_26px_0px_#00000014] jm-z-[100]",
  variants: {
    childAsString: {
      true: "jm-px-4 jm-py-2 jm-font-paragraph-2 jm-text-jutro-new-warm-gray-800"
    }
  }
}), v = d(
  (t, r) => {
    const { context: e, refs: n, open: s, floatingStyles: i, getFloatingProps: l } = j(), a = f([n.setFloating, r]), { styles: m } = g(e, {
      duration: 200
    }), p = x({
      childAsString: typeof t.children == "string"
    });
    return s ? /* @__PURE__ */ o(c, { children: /* @__PURE__ */ o(
      "div",
      {
        ref: a,
        className: p,
        style: {
          ...i,
          ...m
        },
        ...l(t)
      }
    ) }) : null;
  }
);
export {
  v as Content
};
//# sourceMappingURL=Content.js.map
